<template>
  <modal v-if="show" class="modal-insurrance" @close="closeModal(null)">
    <h3 slot="header">{{$resx('YourDocumentText')}}</h3>
    <template slot="body" v-if="doc!==null">
      <form @submit.prevent="saveDocument">
        <div>
          <label class="label">{{doc.label}}</label>
          <input type="text" maxlength="300" v-model="newDoc.value" placeholder="https://www.mywebsite.fr/conditions.pdf" />
        </div>
        <button class="btn btn-primary" :class="{'is-loading' : isSaving}" type="submit" :disabled="isSaving"><span>{{$resx('SaveText')}}</span></button>
        <button class="btn btn-secondary" type="button" @click="closeModal(null)" :disabled="isSaving">{{$resx('CloseText')}}</button>
      </form>
    </template>
  </modal>
</template>
<script>
import modal from '../modal.vue'
import TableDocument from '../../models/booking/document'
import bookingServices from '../../services/bookingServices'

export default {
  props: {
    show: Boolean,
    doc: TableDocument
  },
  data () {
    return {
      isSaving: false,
      newDoc: new TableDocument()
    }
  },
  watch: {
    doc () {
      this.newDoc.value = ''
      if (this.doc !== null) {
        this.newDoc.code = this.doc.code
        this.newDoc.value = this.doc.value
      }
    }
  },
  computed: {
    // camping actuellement sélectionné
    currentCampingId () {
      return this.$store.getters['partner/currentCampingId']
    }
  },
  methods: {
    // fermeture de la popup
    closeModal (doc) {
      this.$emit('onInsurranceLinkClose', doc)
    },

    // poster l'iban
    async saveDocument () {
      this.isSaving = true
      try {
        await bookingServices.updateDocumentUrl(this.currentCampingId, this.newDoc)
        this.doc.value = this.newDoc.value
        if (this.newDoc.value === '') {
          this.doc.validationMessage = this.$resx('MissingLinkText')
          this.doc.isValid = false
        } else {
          this.doc.isValid = true
          this.doc.validationMessage = this.$resx('ValidLinkText')
        }
        this.closeModal(this.doc)
      } catch (error) {
        this.$store.commit('app/showSnack', { type: 'error', message: error.response.data.message })
      } finally {
        this.isSaving = false
      }
    }
  },
  components:
  {
    modal: modal
  }
}
</script>
<style lang="less">
  @import '../../assets/variables.less';

 .modal-insurrance {
    .modal-container
    {
      max-width: 60em;
    }

  h3 {
    font-family:'Playfair Display';
    font-weight: @fontBold;
    font-size: 3em!important;
    color:white!important;
    margin-bottom:1em!important;
  }

  form {
    margin:0 auto;
    max-width:50em;

    >div
    {
      width:100%;
      margin:1em 0;
    }

    label, input {
      width: 100%;
    }

  label {
    color: white;
    display: block;
    margin-bottom: .5em;
  }

    input{
      border-radius:4px;
      padding:.25em 0;
      background-color:rgba(255,255,255,0.05);
      color:white;
      border:none;
    }
  }

  button+button{
    margin-left:1em;
  }

  }
</style>
